document.addEventListener("DOMContentLoaded", function () {
  // 1. Obtener el cuarto <motion-element>
  const footerBlocks = document.querySelectorAll(
    ".footer__blocks > motion-element"
  );
  const targetBlock = footerBlocks[3]; // Cuarto bloque

  if (targetBlock) {
    // 2. Procesar los <a>
    const links = targetBlock.querySelectorAll("a");

    links.forEach((link) => {
      const href = link.getAttribute("href") || "";

      if (href.includes("maps.app.goo.gl")) {
        // Asegurar que se abra en nueva pestaña
        link.setAttribute("target", "_blank");
        link.setAttribute("rel", "noopener noreferrer");
      } else {
        // Desactivar enlace
        link.removeAttribute("href");
        link.classList.remove("reversed-links");
        link.addEventListener("click", (e) => e.preventDefault());
        link.style.cursor = "default";
        link.style.textDecoration = "none";
      }
    });

    // 3. Buscar el <social-icon>
    const socialIcon = document.querySelector("social-icon.block.mt-15");

    if (socialIcon) {
      // Clonarlo para moverlo
      const clonedIcon = socialIcon.cloneNode(true);

      // Agregar clase para aplicar estilos desde CSS
      clonedIcon.classList.add("social-footer-clone");

      // Insertar debajo de la lista del cuarto bloque
      const collapsibleContent = targetBlock.querySelector(
        ".collapsible-content"
      );
      const ul = collapsibleContent.querySelector("ul");

      if (ul && collapsibleContent) {
        collapsibleContent.insertBefore(clonedIcon, ul.nextSibling);
      }

      // Eliminar el original
      socialIcon.remove();
    }
  }
});
